import { useEffect, useState } from 'react'
import { useMatch, useNavigate, useParams } from 'react-router-dom'
import { asyncGetOVById } from 'store/OVContext'
import { useDispatch, useSelector } from 'store/store'
import OvDetailsTabs from './components/OvDetailsTabs'
import {
  Page,
  LoadingModal,
  ToolBar,
  OVOrderHeader,
  StatisticsCard,
  OptionProps,
  Icon
} from 'components'
import * as S from './styles'
import { asyncSetOvSap, getOvBinds, setOVSelected } from 'store/OVContext/ovSlice'

import {
  OVDetalheResponse,
  OvMaintenanceBody,
  SapOptionsToOvStatus
} from 'store/OVContext/ovContextTypes'
import { TypesValidations } from 'constants/enums'
import { FormProvider, useForm } from 'react-hook-form'
import { convertBooleanApiValue } from 'commons/utils/string'
import { formatToPTBRNumber } from 'commons/utils/number'
import { getPaymentsTerms } from 'services/draft'
import { PaymentMethodsProps } from 'container/CreateOrder/components/TopSection'
import { getClientAddress } from 'services/salesOrder'
import { AddressResponse } from 'services/salesOrder/types'
import { toast } from 'react-toastify'
import { getUser } from 'commons/utils/user'
import { OvMaintenanceResponse } from 'services/manage_ov/interface'
import { oVMaintenance } from 'services/manage_ov'
import { getOvStatusOptionsToSap } from './utils'
import { CancelOvReason } from 'container/SalesOrder/components/OvsTab/components/CancelOvForm'
import {
  SalesOrderOvCancelOperation,
  SalesOrderOvDeleteOperation
} from 'store/SalesOrderContext/salesOrderSlice'
import { setOvInitialTab } from 'store/StructuralContext/structuralSlice'
import { URL_CONST } from 'constants/urls'
import {
  Company,
  defaultOvTypeOptions,
  MaterialType,
  Organization,
  OVOrder
} from 'constants/enums'

export default function ManageOVDetails() {
  const { ovNumber } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const matchJustifyRoute = !!useMatch(`${URL_CONST.MANAGE_OV}/:ovNumber/justificar`)

  const {
    ovSelected,
    loadingOv,
    savingOv,
    detailedInfo: { FaturamentoEntrega },
    detailedInfo,
    observation,
    alertJustification
  } = useSelector(({ ov }) => ov)

  const dataToHeader = {
    cd_tipo_orde: ovSelected?.Cabecalho?.CodigoTipoOrdem ?? '',
    nr_dias_adic: ovSelected?.Cabecalho?.PrazoExtra?.toString() ?? '0',
    cd_clie_entr: ovSelected?.Cabecalho?.EnderecoEntrega ?? '',
    nr_pedi_clie: ovSelected?.Cabecalho?.NumeroPedidoCliente ?? ' ',
    dt_ano_mes_cota: ovSelected?.Cabecalho?.MesCota ?? '',
    ds_grup_clie: ovSelected?.Cabecalho?.SubCanalDistribuicao ?? '',
    pc_dsct: ovSelected?.Cabecalho?.Desconto ?? 0,
    cd_seto_atvd: ovSelected?.Cabecalho?.Setor?.substring(0, 2) ?? '',
    nr_insc_estl: ovSelected?.Cabecalho?.InscricaoEstadual ?? '',
    fl_mto_prep:
      ovSelected?.Cabecalho?.TipoMaterial === MaterialType.MTO
        ? TypesValidations.YES
        : TypesValidations.NO,
    cd_cent_matr: ovSelected?.Cabecalho?.CodigoCentroMaterial ?? '',
    fl_prmt_desd: TypesValidations.YES,
    cd_cond_pgto: ovSelected?.Cabecalho?.CondicaoPagamento?.substring(0, 4) ?? '',
    cd_escr_vend: ovSelected?.Cabecalho?.CodigoEscritorioVenda ?? ''
  }
  const initialFields = {
    ...dataToHeader
  }

  const defaultClient = {
    cd_clie: ovSelected?.Cabecalho?.CodigoSapCliente,
    nm_clie: ovSelected?.Cabecalho?.RazaoSocial,
    cd_empr: Company.ALPA,
    cd_orgn_vend: Organization.ALHV,
    cd_canl_dstb: ovSelected?.Cabecalho?.CanalDistribuicao?.substring(0, 2),
    cd_seto_atvd: ovSelected?.Cabecalho?.Setor.substring(0, 2),
    cd_regi_vend: ovSelected?.Cabecalho?.RegiaoVenda.substring(0, 6),
    ds_regi_vend: ovSelected?.Cabecalho?.RegiaoVenda?.substring(8)?.trim(),
    nr_cnpj_cpf: ovSelected?.Cabecalho?.CnpjCpf,
    cd_escr_vend: ovSelected?.Cabecalho?.CodigoEscritorioVenda
  }
  const methods = useForm({
    mode: 'all',
    reValidateMode: 'onBlur',
    defaultValues: initialFields
  })

  useEffect(() => {
    if (Object.keys(ovSelected).length) {
      methods.reset({
        cd_tipo_orde: ovSelected?.Cabecalho?.CodigoTipoOrdem ?? '',
        nr_dias_adic: ovSelected?.Cabecalho?.PrazoExtra?.toString() ?? '0',
        cd_cond_pgto: ovSelected?.Cabecalho?.CondicaoPagamento?.substring(0, 4) ?? '',
        fl_prmt_desd: TypesValidations.YES,
        cd_clie_entr: ovSelected?.Cabecalho?.EnderecoEntrega ?? '',
        ds_grup_clie: ovSelected?.Cabecalho?.SubCanalDistribuicao ?? '',
        nr_pedi_clie: ovSelected?.Cabecalho?.NumeroPedidoCliente ?? ' ',
        dt_ano_mes_cota: ovSelected?.Cabecalho?.MesCota || '',
        pc_dsct: ovSelected?.Cabecalho?.Desconto ?? 0,
        cd_seto_atvd: ovSelected?.Cabecalho?.Setor?.substring(0, 2) ?? '',
        nr_insc_estl: ovSelected?.Cabecalho?.InscricaoEstadual ?? '',
        fl_mto_prep:
          ovSelected?.Cabecalho?.TipoMaterial === MaterialType.MTO
            ? TypesValidations.YES
            : TypesValidations.NO,
        cd_cent_matr: ovSelected?.Cabecalho?.CodigoCentroMaterial ?? '',
        cd_escr_vend: ovSelected?.Cabecalho?.CodigoEscritorioVenda ?? ''
      })
      setInputAutocomplete(ovSelected?.Cabecalho?.CondicaoPagamento)
      getAddress()
    }
  }, [Object.keys(ovSelected).length])

  useEffect(() => {
    if (alertJustification || matchJustifyRoute) {
      dispatch(setOvInitialTab(2))

      if (ovNumber) {
        dispatch(asyncGetOVById(ovNumber))
      }
    }
  }, [alertJustification, matchJustifyRoute])

  const [ovsSapData, setOvsSapData] = useState<SapOptionsToOvStatus>(
    {} as SapOptionsToOvStatus
  )
  const [inputAutocomplete, setInputAutocomplete] = useState<string>('')
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodsProps[]>([])
  const [addressOptions, setAddressOptions] = useState<OptionProps[]>([])
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const handleOvToSap = () => {
    dispatch(
      asyncSetOvSap({
        type: ovsSapData.type,
        body: ovsSapData.body,
        reload: !(observation?.NegociacaoDiferenciada === TypesValidations.YES)
      })
    )
  }

  const getCondicoesPagamento = async () => {
    const returnApi = await getPaymentsTerms({
      qt_rowcount: 999,
      cd_empr: '',
      cd_orgn_vend: '',
      cd_canl_dstb: '',
      cd_tipo_orde: '',
      fl_orde_tele_vend: TypesValidations.NO,
      cd_cond_pgto: ''
    })
    if (returnApi) {
      localStorage.setItem('paymentMethods', JSON.stringify(returnApi))
      setPaymentMethods(returnApi)
    }
  }

  const getAddress = () =>
    getClientAddress({
      cd_empr: defaultClient.cd_empr,
      cd_orgn_vend: defaultClient.cd_orgn_vend,
      cd_canl_dstb: defaultClient.cd_canl_dstb,
      cd_seto_atvd: defaultClient.cd_seto_atvd,
      cd_clie: defaultClient.cd_clie
    }).then((response: AddressResponse[]) => {
      setAddressOptions(
        response.map((address) => ({
          value: address.cd_pcro,
          title: address.ds_endr
        }))
      )
      if (response.length === 1) {
        methods.setValue('cd_clie_entr', response[0].cd_pcro)
      }
      if (response.length > 1) {
        methods.setValue(
          'cd_clie_entr',
          response?.find(
            (address) => address.ds_endr === ovSelected?.Cabecalho?.EnderecoEntrega
          )?.cd_pcro ?? ''
        )
      }
    })

  useEffect(() => {
    getCondicoesPagamento()
    if (ovNumber) {
      dispatch(asyncGetOVById(ovNumber))
      dispatch(getOvBinds(ovNumber))
    }
    return () => {
      dispatch(setOVSelected({} as OVDetalheResponse))
    }
  }, [])
  const editOv = async (ovID: string, requestBody: OvMaintenanceBody) => {
    try {
      setLoading(true)
      const res: OvMaintenanceResponse = await oVMaintenance(ovID, requestBody)
      if (res.OperacaoRealizada) {
        toast.success('Ordem de Venda editada com sucesso.')
        methods.reset({ ...methods.getValues() })
      } else {
        toast.error(res?.Mensagem || `Não foi possível editar a Ordem de Venda.`)
      }
    } catch (error) {
      toast.error(`Erro ao editar a Ordem de Venda.`)
    } finally {
      setLoading(false)
    }
  }
  const handleEditOv = (data: typeof initialFields) => {
    const editOvRequestBody = {
      CodigoEntrega: data.cd_clie_entr,
      CodigoUsuarioAlteracao: getUser(),
      CondicaoPagamento: data.cd_cond_pgto,
      DiasAdicionais: +data.nr_dias_adic,
      NumeroOrdemVenda: ovNumber,
      NumeroPedidoCliente: data.nr_pedi_clie,
      TipoOrdem: data.cd_tipo_orde,
      DataDesejadaCliente: FaturamentoEntrega.DataDesejadaCliente,
      DataPrevistaFaturamento: FaturamentoEntrega.DataPrevisaoFaturamento
    }
    if (ovNumber) {
      editOv(ovNumber, editOvRequestBody as OvMaintenanceBody)
    }
  }

  const quotasMonth = ovSelected?.Cabecalho?.MesCota
    ? [
        {
          dt_ano_mes_cota: ovSelected?.Cabecalho?.MesCota,
          ds_ano_mes_cota: ovSelected?.Cabecalho?.MesCota?.replace(
            /([\d]{4})([\d]{2})/,
            '$2/$1'
          ),
          fl_ano_mes_cota_antp: TypesValidations.NO
        }
      ]
    : []
  useEffect(() => {
    if (
      ovSelected.statusOrdemVenda &&
      detailedInfo?.Tracking?.DataUltimaAlteracao &&
      ovNumber
    ) {
      const { statusOrdemVenda } = ovSelected
      setOvsSapData(
        getOvStatusOptionsToSap([
          {
            number: ovNumber,
            changeDate: detailedInfo?.Tracking?.DataUltimaAlteracao,
            statusKey: statusOrdemVenda
          }
        ])
      )
    }
  }, [ovSelected, detailedInfo?.Tracking?.DataUltimaAlteracao])

  const dispatchCancelOperation = (data: CancelOvReason) => {
    const body = {
      ordensVenda: [
        {
          numeroOrdem: ovNumber as string,
          dataUltimaAlteracao: detailedInfo?.Tracking?.DataUltimaAlteracao
        }
      ],
      codigoMotivo: data.reasonsRefusal,
      justificativa: data.refusalDescription
    }
    dispatch(
      SalesOrderOvCancelOperation(
        body,
        { paginas: 0, linhas: 1 },
        ovSelected?.Cabecalho?.NumeroPedidoRascunho ?? ''
      )
    )
  }

  const dispatchDeleteOperation = () => {
    dispatch(
      SalesOrderOvDeleteOperation(
        [ovNumber as string],
        { paginas: 0, linhas: 1 },
        ovSelected?.Cabecalho?.NumeroPedidoRascunho ?? ''
      )
    )
    if (ovSelected?.Cabecalho?.NumeroPedidoRascunho) {
      navigate(
        `${URL_CONST.MANAGE_ORDER}/${ovSelected?.Cabecalho?.NumeroPedidoRascunho}`,
        { replace: true }
      )
    } else {
      navigate(`${URL_CONST.MANAGE}`, { replace: true })
    }
  }

  return loadingOv ? (
    <LoadingModal />
  ) : (
    <>
      <Page
        fullwidth
        renderHeaderComponent={
          <ToolBar
            orderStatus="ordered"
            ovSapNumber={ovSelected?.Cabecalho?.NumeroOrdemVendaSap}
            ovPortalNumber={ovNumber}
            showButtonMore={true}
            isButtonCancel={
              +ovSelected?.Cabecalho?.CodigoStatus >= 0 &&
              +ovSelected?.Cabecalho?.CodigoStatus <= 8
            }
            onClickCancel={dispatchCancelOperation}
            isButtonDelete={
              +ovSelected?.Cabecalho?.CodigoStatus === 0 &&
              !ovSelected?.Cabecalho?.NumeroOrdemVendaSap
            }
            onClickDelete={dispatchDeleteOperation}
            fullWidth
            isButtonTrack
            isND={observation?.NegociacaoDiferenciada === TypesValidations.YES}
            sapButtonsOptions={ovsSapData}
            onClickSap={handleOvToSap}
            isLoadingButtonSave={savingOv}
            originOrder={ovSelected?.Cabecalho?.OrigemPedido}
          />
        }
      >
        <FormProvider {...methods}>
          <>
            <OVOrderHeader
              type={OVOrder.OV}
              postDraft={async () => {
                setOpen(true)
                handleEditOv(methods.getValues())
              }}
              loading={loading}
              quotasMonth={quotasMonth}
              defaultClient={defaultClient}
              paymentMethods={paymentMethods}
              addressOptions={addressOptions}
              clientOvTypes={defaultOvTypeOptions}
              inputAutocomplete={inputAutocomplete}
              inputAutocompleteSaleRegion={ovSelected?.Cabecalho?.RegiaoVenda ?? ''}
              setAddressOptions={setAddressOptions}
              setInputAutocomplete={setInputAutocomplete}
              defaultExpanded={open}
            />
            <S.StatisticsRow>
              <StatisticsCard
                icon={<Icon icon="sandal" color="#94A3BC" size="25" />}
                title="Quantidade total OV"
                mainValue={ovSelected?.Faturamento?.QuantidadeTotalOV?.toString()}
              >
                <S.InnerRow>
                  <S.Box>
                    <S.BoxTitle>Total faturado</S.BoxTitle>
                    <S.BoxValue>
                      {ovSelected?.Faturamento?.QuantidadeTotalFaturada}
                    </S.BoxValue>
                  </S.Box>
                  <S.Box>
                    <S.BoxTitle>Saldo p/ faturar</S.BoxTitle>
                    <S.BoxValue>
                      {ovSelected?.Faturamento?.QuantidadeSaldoFaturar}
                    </S.BoxValue>
                  </S.Box>
                  <S.Box>
                    <S.BoxTitle>Total cancelado</S.BoxTitle>
                    <S.BoxValue>
                      {ovSelected?.Faturamento?.QuantidadeTotalCanceladoOV}
                    </S.BoxValue>
                  </S.Box>
                </S.InnerRow>
              </StatisticsCard>
              <StatisticsCard
                icon={<Icon icon="money" color="#94A3BC" size="25" />}
                title="Valor de referência OV"
                mainValue={formatToPTBRNumber(
                  ovSelected?.Faturamento?.ValorReferenciaOV ?? 0,
                  false
                )}
              >
                <S.InnerRow>
                  <S.Box>
                    <S.BoxTitle>Total SAP</S.BoxTitle>
                    <S.BoxValue>
                      {formatToPTBRNumber(ovSelected?.Faturamento?.ValorTotalSAP ?? 0)}
                    </S.BoxValue>
                  </S.Box>
                  <S.Box>
                    <S.BoxTitle>Diferença entre portal/SAP</S.BoxTitle>
                    <S.BoxValue>
                      {formatToPTBRNumber(
                        ovSelected?.Faturamento?.ValorDiferencaPortalSap ?? 0
                      )}
                    </S.BoxValue>
                  </S.Box>
                  <S.Box>
                    <S.BoxTitle>Total faturado</S.BoxTitle>
                    <S.BoxValue>
                      {formatToPTBRNumber(
                        ovSelected?.Faturamento?.ValorTotalFaturado ?? 0
                      )}
                    </S.BoxValue>
                  </S.Box>
                </S.InnerRow>
              </StatisticsCard>
            </S.StatisticsRow>
            <OvDetailsTabs
              hasShipment={
                [65, 70].includes(+ovSelected?.Cabecalho?.CodigoStatus) ||
                convertBooleanApiValue(ovSelected?.Cabecalho?.FlagRemessa)
              }
              isBilled={
                [75, 80].includes(+ovSelected?.Cabecalho?.CodigoStatus) ||
                convertBooleanApiValue(ovSelected?.Cabecalho?.FlagFatura)
              }
            />
          </>
        </FormProvider>
      </Page>
    </>
  )
}
